import styled from 'styled-components'
import { media } from 'modules/common/components/ui/utils'

const Item = styled.span`
  background-color: ${({theme}) => theme.PillBackgroundColor };
  color: ${({theme}) => theme.PillColor };
  position: absolute;
  font-size: 10px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  right: -22px;
  top: -14px;
  text-align: center;
  border-radius: 50%;
  opacity: 0;
  transition: opacity .1s ease-in, transform .1s ease-in;
  transform: scale(.8);
  transform-origin: center;
  font-weight: 700;

  ${({visible}) => visible && `
    transform: scale(1);
    opacity: 1;
  `}
  ${media.maxWidth(1023)`
    ${({plainTextOnSmall}) => plainTextOnSmall && `
        background-color: transparent;
        color: inherit;
        position: static;
        font-size: inherit;
        line-height: inherit;
        transform: scale(1);
        opacity: 1;
        font-weight: inherit;
        &:before{
          content: '(';
        }
        &:after{
          content: ')';
        }
    `}
  `}
`;

export default Item



// WEBPACK FOOTER //
// ./src/modules/common/components/pill/Pill.js